import { render, staticRenderFns } from "./func.vue?vue&type=template&id=06f014cc&scoped=true"
import script from "./func.vue?vue&type=script&lang=js"
export * from "./func.vue?vue&type=script&lang=js"
import style0 from "./func.vue?vue&type=style&index=0&id=06f014cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f014cc",
  null
  
)

export default component.exports